import React, { Component } from 'react';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import { withRouter } from 'react-router';
import { QRSample } from '../QRPages';
import { getQRDesign, moveToFirstPage } from 'admin/actions/qr-designer';
import Button from 'admin/components/shared/Button';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import { isAllowedPath } from 'admin/routes';
import { toQueryParams } from 'admin/utils'
import styles from './styles.scss';

class QRDisplay extends Component {
  componentDidMount() {
    this.props.getQRDesign(toQueryParams({ private_money_id: this.props.userPrivateMoney.id }));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userPrivateMoney.id !== this.props.userPrivateMoney.id) {
      this.props.getQRDesign(toQueryParams({ private_money_id: this.props.userPrivateMoney.id }));
    }
  }

  handleClick = () => {
    this.props.moveToFirstPage();
    this.props.history.push('/settings/qr-designer');
  }

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '各種設定', href: '', active: true },
      { value: 'QRデザイン', href: '', active: true },
    ];

    return (
      <div>
        <Breadcrumb items={crumb} />
        <div styleName='headline'>QRデザイン</div>
        <div styleName='main'>
          <div styleName='preview'>
            <QRSample />
          </div>
          {
            isAllowedPath('/settings/qr-designer', this.props.user) ?
              (<Button styleName='edit-button' onClick={this.handleClick}>編集</Button>) : null
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  userPrivateMoney: state.userPrivateMoney.selectedMoney,
});

export default withRouter(connect(mapStateToProps, { getQRDesign, moveToFirstPage })(CSSModules(QRDisplay, styles)));
